import React from 'react';
import clsx from 'clsx';

const SkeletonListItemMobile = ({
  items,
  loading,
}: {
  items: number;
  loading: boolean;
}) => {
  return (
    <>
      {loading &&
        [...Array(items)].map((e, index) => (
          <li
            className={clsx(
              'flex',
              'flex-col',
              'gap-2',
              'p-4',
              'border',
              'border-solid',
              'bg-gray-100',
              'border-gray-200',
              'rounded',
              'mb-4',
              'skeleton',
              'min-h-[200px]',
              'md:min-h-[140px]'
            )}
            key={index}
          ></li>
        ))}
    </>
  );
};

export default SkeletonListItemMobile;
